export const autoHeight = true;
export const autoplayButton = false;
export const autoplayButtonOutput = false;
export const autoplayHoverPause = true;
export const autoplayTimeout = 5000;
export const mouseDrag = true;
export const slideBy = 'page';
export const speed = 750;
export const swipeAngle = 40;
